export default __webpack_public_path__ + "static/media/slide1.4f60a1ff.png";